import { getClaimParams } from "../../../../utils/extensions/drops/get-claim-params.js";
import { isGetContractMetadataSupported } from "../../../common/read/getContractMetadata.js";
import * as GeneratedClaim from "../../__generated__/IDrop1155/write/claim.js";
import { isGetActiveClaimConditionSupported } from "../read/getActiveClaimCondition.js";
/**
 * Claim ERC1155 NFTs to a specified address
 * @param options - The options for the transaction
 * @extension ERC1155
 * @example
 * ```ts
 * import { claimTo } from "thirdweb/extensions/erc1155";
 * import { sendTransaction } from "thirdweb";
 *
 * const transaction = claimTo({
 *   contract,
 *   to: "0x...",
 *   tokenId: 0n,
 *   quantity: 1n,
 * });
 *
 * await sendTransaction({ transaction, account });
 * ```
 * @throws If no claim condition is set
 * @returns The prepared transaction
 */
export function claimTo(options) {
    return GeneratedClaim.claim({
        contract: options.contract,
        async asyncParams() {
            const params = await getClaimParams({
                type: "erc1155",
                contract: options.contract,
                to: options.to,
                quantity: options.quantity,
                from: options.from,
                tokenId: options.tokenId,
            });
            return {
                ...params,
                tokenId: options.tokenId,
            };
        },
    });
}
/**
 * Checks if the `claimTo` method is supported by the given contract.
 * @param availableSelectors An array of 4byte function selectors of the contract. You can get this in various ways, such as using "whatsabi" or if you have the ABI of the contract available you can use it to generate the selectors.
 * @returns A boolean indicating if the `claimTo` method is supported.
 * @extension ERC1155
 * @example
 * ```ts
 * import { isClaimToSupported } from "thirdweb/extensions/erc1155";
 *
 * const supported = isClaimToSupported(["0x..."]);
 * ```
 */
export function isClaimToSupported(availableSelectors) {
    return [
        // has to support the claim method
        GeneratedClaim.isClaimSupported(availableSelectors),
        // has to support the getActiveClaimCondition method
        isGetActiveClaimConditionSupported(availableSelectors),
        // requires contractMetadata for claimer proofs
        isGetContractMetadataSupported(availableSelectors),
    ].every(Boolean);
}
//# sourceMappingURL=claimTo.js.map